export default "__VITE_ASSET__u6Z7KgGY__"